import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/thriwe-marketplace-ui/thriwe-marketplace-ui/app/component/spinner-loader.tsx");
